import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { UnmountAllSwals } from "source/app/services/Shared/RenderSwal/RenderSwal";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";


export async function SaveCalendarEditorStateAndCloseAsync(
    state: ICalendarEventEditorState,
    newEventName: string,
    SaveAction: (withEventData?: ICalendarEvent) => Promise<void>
) {
    const newState: ICalendarEvent = {
        ...state.calendarEvent,
        name: newEventName,
    };

    UnmountAllSwals();
    await SaveAction(newState);
}
